import React , { useCallback } from 'react';

import images from '../../assets';
import Store from 'store';
import store from '../../store';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import apiClient from '../../_utils/axios';
import { countBasketItem } from '../../_actions/userAction';
import { FavoriModal } from '../designs/DesignPage';
import { useTranslation } from 'react-i18next';

// const preminumimg = {
//   width: 50,
//   height: 50,
//   cursor: 'pointer',
//   display: 'inline-block',
//   transition: 'transform 0.3s ease, box-shadow 0.3s ease'
// };

const hoverStyle = {
  transform: 'scale(1.1)',
  boxShadow: '0 10px 20px rgba(0, 0, 0, 0.2)'
};

export  const LikeBtn = ({ preminumimg, onFavClick, like, remove, productId, onRemove}) => {
  const {t} = useTranslation();
  const history = useHistory();
  const dispatch = useDispatch();
  
  const [isLike, setIsLike] = React.useState(like);
  React.useEffect(() => { setIsLike(like); }, [like]);

  const [hovered, setHovered] = React.useState(false);
  const [showfavmodal, setShowfavmodal] = React.useState(false);

  const handleMouseEnter = () => setHovered(true);
  const handleMouseLeave = () => setHovered(false);

  const OffFavModal = useCallback(() => {
    setShowfavmodal(false);
  }, []);

  const onOffLike = useCallback(() => {
    if(isLike === true){
      setIsLike(false);
    }else{
      setIsLike(true);
    }
  });

  const goFavori = useCallback(() => {
    history.push('/mypage/purchase/favori');
  }, [history]);

  const ShowFav = useCallback(
    (id) => {
      if (!Store.get('accessToken')) {
        let err = t('sign_in_to_your_account');

        alert(err);
        return history.push('/auth');
      }
      const { interest_group } = store.getState();

      if (interest_group.length < 1) {
        alert(t('NofollowingGroup'));
        return goFavori();
      }
      setShowfavmodal(!showfavmodal);
    },
    [history, goFavori]
  );

  return (
    <>
      <div style={{ ...preminumimg, marginRight: 16 }}>
        <img
          alt=""
          src={
            !remove
              ? (isLike ? images.icon_liked : images.icon_favori_rmv)
              : (isLike ? images.icon_black_liked : images.icon_favori_rmv)
          }
          style={hovered ? hoverStyle : {}}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
          onClick={() => {
            if (isLike) {
              setIsLike(false);
              try {
                if (typeof onRemove === 'function') {
                  onRemove();
                } else if (typeof onFavClick === 'function') {
                  onFavClick();
                } else {
                  ShowFav();
                }
              } catch (e) {
                setIsLike(true); 
              }
            } else {
              setIsLike(true);
              ShowFav();
            }
          }}
        />
      </div>

      <FavoriModal
        show={showfavmodal}
        onClose={OffFavModal}
        onConfirm={goFavori}
        target={productId}
        onOffLike={onOffLike}
      />
    </>
  );

};

export default LikeBtn;
